import { FontEntry } from '../../types/font'

export const roboto: FontEntry = {
  displayName: 'Roboto',
  weights: {
    300: {
      normal: { file: 'Roboto-Light', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-LightItalic', extension: 'ttf', format: 'truetype' }
    },
    400: {
      normal: { file: 'Roboto-Regular', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-Italic', extension: 'ttf', format: 'truetype' }
    },
    700: {
      normal: { file: 'Roboto-Bold', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-BoldItalic', extension: 'ttf', format: 'truetype' }
    }
  }
}
